import common from './common';
import home from './home';
import aLeague from './aLeague';

export default { common, home, aLeague };
